module.exports = __webpack_public_path__ + "img/青丘男.a3bbbff1.png";